export const systemFields = [
    'candkey',
    'sotrkey',
    'rekrkey',
    'whocreatekey',
    'contkey',
    'cntresultcode',
    'nextcnttype',
    'nexctcnt_objectivecode',
    'cntobjectivecode',
    'pplkey',
    'nextcnt_sotrkey',
    'orgkey',
    'town_code',
    'posreason_code',
    'replace_ppl_code',
    'grossnet_code',
    'workplace_code',
    'typeofemployment_code',
    'chartofwork_code',
    'typeofexpirience_code',
    'ppl_zakaz_code',
    'budget_code',
    'department_code',
    'sex_code',
    'typeofeducation_code',
    'salaryvaluta',
    'price',
    'finprim',
    'whomarket',
    'prjtype',
    'parentprj',
    'kadryorgkey',
    'kadryanckey',
    'valuta',
    'reqchildprj',
    'ispkey',
    'poskey',
    'zakorgkey',
    'infaboutancor',
    'docname',
    'sekrwork',
    'whencreatedate',
    'whenchange',
    'whochange',
    'whenbeginchange',
    'whenendchange',
    'howmanylettersadded',
    'conpplkey',
    'firstclassif',
    'initdate',
    'mainkey',
    'addcode',
    'family',
    'writing',
    'duration',
    'terminology',
    'prim',
    'addnum',
    'sekrkey',
    'num',
    'level_code',
    'country_code',
    'region_code',
    'townkey',
    'region',
    'name_code',
    'zakazdepartkey',
    'business_trips_code',
];

export const hiddenFields = {
    IntRecrRequest: [
        'posdetails.posname',
        'prjeditmain.town',
        'datefrom'
    ]
}

export const isArrayField = {
    PplAnketa: ['NISSAN_COMPETENCIES', 'NISSAN_COMPUTER_SKILLS', 'ppleducation', 'employment-places'],
};
